// extracted by mini-css-extract-plugin
module.exports = {"containerContent":"GiftingPage_containerContent__1OZN3","containerTopPadding":"GiftingPage_containerTopPadding__28bFn"};